import {ModuleWithProviders, NgModule} from '@angular/core';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {QuoteListModule} from '../quotes/quote-list-module';
import {SharedModule} from '../shared/shared.module';
import {ProductCardComponent} from './components/product-card/product-card.component';
import {ProductSortedSearchComponent} from './components/product-sorted-search/product-sorted-search.component';
import {CollectionPageComponent} from './containers/collection-page/collection-page.component';
import {ProductPageComponent} from './containers/product-page/product-page.component';
import {AttributeEffects} from './effects/attributes-effects.service';
import {CollectionEffects} from './effects/collection.effects';
import {ProductEffects} from './effects/product.effects';
import {ProductsRoutingModule} from './products-routing.module';
import {reducers} from './reducers';
import {ProductExistsGuard} from './services/product-exists.guard';
import {ProductsApiService} from './services/products-api.service';
import {ProductsAttributesApiService} from './services/products-attributes-api.service';
import {SearchFilterConverter} from './services/search-filter-converter';
import {GalleryModule} from 'ng-gallery';
import {AdvancedSearchComponent} from './components/advanced-search/mobile-advanced-search.component';
import {AdvancedSearchPageComponent} from './containers/advanced-search-page/advanced-search-page.component';
import {ReactiveComponentModule} from '@ngrx/component';
import {CmsModule} from '../cms/cms.module';
import {AdvancedSearchSelectComponent} from './components/advanced-search-select/advanced-search-select.component';
import {MAT_SELECT_SCROLL_STRATEGY} from "@angular/material/select";
import {BlockScrollStrategy, Overlay} from "@angular/cdk/overlay";


@NgModule({
    imports: [
        StoreModule.forFeature('products', reducers),
        EffectsModule.forFeature([CollectionEffects, ProductEffects, AttributeEffects]),
    ],
    declarations: []
})
export class RootProductsModule {
}


@NgModule({})
export class ProductsModule {
    static forRoot(): ModuleWithProviders<RootProductsModule> {
        return {
            ngModule: RootProductsModule,
            providers: [
                ProductExistsGuard,
                ProductsApiService,
                ProductsAttributesApiService,
                SearchFilterConverter
            ]
        };
    }
}

export function scrollFactory(overlay: Overlay): () => BlockScrollStrategy {
    return () => overlay.scrollStrategies.block();
}
@NgModule({
    imports: [
        SharedModule,
        ProductsRoutingModule,
        QuoteListModule,
        InfiniteScrollModule,
        GalleryModule,
        ReactiveComponentModule,
        CmsModule
    ],
    declarations: [
        CollectionPageComponent,
        ProductPageComponent,
        ProductCardComponent,
        ProductSortedSearchComponent,
        AdvancedSearchComponent,
        AdvancedSearchPageComponent,
        AdvancedSearchSelectComponent
    ],
    providers: [
        { provide: MAT_SELECT_SCROLL_STRATEGY, useFactory: scrollFactory, deps: [Overlay] }
    ]
})
export class LazyProductsModule {
}
